export { createDocumentRoute } from './route'
